import React from "react";

export default function Button (props) {
  return <button  style={{
                    backgroundColor: '#2F2F2F',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    padding: '10px 16px',
                    fontSize: '14px',
                    fontWeight: '600',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    alignContent:'center',
                    cursor: 'pointer',
                    opacity: 1,
                }} className='button'  {...props}>

    {props.children}

  </button>
}
